import { message, } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { SelectedDelivery } from 'public/context/CartContext';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { FarmDeliveries } from 'types/FarmData';
import { Input } from 'ui';
import { AdresSearch, AMKResponse } from 'ui/AdressSearch';
import { StyledDelivery } from '../style';

interface DeliveryDeliveryProps {
  selectedDelivery: FarmDeliveries;
  setSelectedDeliveryData: React.Dispatch<
    React.SetStateAction<SelectedDelivery[] | null>
  >;
  selectedDeliveryData: SelectedDelivery[] | null;
}

const DeliveryDelivery = ({
  selectedDelivery,
  setSelectedDeliveryData,
  selectedDeliveryData,
}: DeliveryDeliveryProps) => {
  const intl = useIntl();
  const [isOpenAddressSearch, setIsOpenAddressSearch] =
    useState<boolean>(false);
  const form = useFormInstance();

  return (
    <StyledDelivery>
      <div className={'delivery'}>
        <div className={'content'}>
          <Input
            label={intl.formatMessage({ id: 'general.your_address' })}
            layout={'vertical'}
            className={'delivery-delivery-input'}
            size={'large'}
            name={'delivery_address'}
            validations={'required'}
            onClick={() => setIsOpenAddressSearch(true)}
            readOnly
          />
          <AdresSearch
            isOpen={isOpenAddressSearch}
            setIsOpen={setIsOpenAddressSearch}
            onItemSelect={(event: AMKResponse) => {
              if (event.data?.code) {
                if (event.data?.irAdrese) {
                  let finalAddress = `${event.data?.address}`;

                  if (!!event.data?.zipCode) {
                    finalAddress = `${event.data?.address}, ${event.data?.zipCode}`;
                  }
                  form.setFieldValue('delivery_address', finalAddress);
                  form.validateFields(['delivery_address']);
                  setSelectedDeliveryData([
                    ...(selectedDeliveryData || []),
                    {
                      id: undefined,
                      selectedDeliveryId: selectedDelivery.id,
                      city: event.data?.pilName ?? event.data?.novName,
                      address: finalAddress,
                      firm_name: selectedDelivery?.type,
                      name: selectedDelivery.name,
                      price: selectedDelivery.price,
                    },
                  ]);
                  setIsOpenAddressSearch(false);
                } else {
                  message.error(
                    intl.formatMessage({ id: 'message.add_full_address' })
                  );
                }
              }
            }}
          />
        </div>
      </div>
    </StyledDelivery>
  );
};

export default DeliveryDelivery;
